var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rest-list-column',{attrs:{"prop":_vm.prop,"title":_vm.title,"width":_vm.width,"min-width":_vm.minWidth,"formatter":_vm.formatter,"sortable":_vm.sortable,"filter-number":true}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-705be036","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/rest/RestListColumnNumber.vue
// module id = null
// module chunks = 